import React, { useContext } from 'react';
import ClientsEventBookingContext from './ClientsEventBookingContext';

export default () => useContext(ClientsEventBookingContext);
